import React from 'react'
import { withStyles } from 'material-ui/styles'
import styles from './styles'

class FiberImage extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const {
      src,
      classes
    } = this.props

    return (
      <img
        className={ classes.fiberImage}
        alt=""
        src={src}
      />
    )
  }
}

export default withStyles(styles)(FiberImage)




// WEBPACK FOOTER //
// ./src/components/common/results/views/fiber/types/components/fiberimage/index.js